import { Component, computed, inject } from "@angular/core";
import { DateTime, SHOW_TALENT_POOL_UI, UserPermission } from "@ankaadia/ankaadia-shared";
import { PageheaderComponent } from "@ankaadia/ui";
import { SettingsService } from "../../shared/services/settings.service";
import { TranslateDirective } from "../../shared/transloco/translate.directive";
import { NewUiDashboardBirthdaysComponent } from "./new-ui-dashboard-birthadays/new-ui-dashboard-birthdays.component";
import { NewUiDashboardCandidateStatusComponent } from "./new-ui-dashboard-candidate-status/new-ui-dashboard-candidate-status.component";
import { NewUiDashboardEventsComponent } from "./new-ui-dashboard-events/new-ui-dashboard-events.component";
import { NewUiDashboardMilestoneCandidateComponent } from "./new-ui-dashboard-milestone-candidate/new-ui-dashboard-milestone-candidate.component";
import { NewUiDashboardMilestoneComponent } from "./new-ui-dashboard-milestone/new-ui-dashboard-milestone.component";
import { NewUiDashboardOpenTasksComponent } from "./new-ui-dashboard-open-tasks/new-ui-dashboard-open-tasks.component";
import { NewUiDashboardReleaseNotesComponent } from "./new-ui-dashboard-release-notes/new-ui-dashboard-release-notes.component";
import { NewUiDashboardSharingComponent } from "./new-ui-dashboard-sharing/new-ui-dashboard-sharing.component";
import { NewUiDashboardTalentPoolRequestsComponent } from "./new-ui-dashboard-talent-pool-requests/new-ui-dashboard-talent-pool-requests.component";
import { NewUiDashboardTalentPoolSharingsComponent } from "./new-ui-dashboard-talent-pool-sharings/new-ui-dashboard-talent-pool-sharings.component";
import { translateSafely } from "@ankaadia/ankaadia-shared-frontend";
import { TalentPoolConfigService } from "../talent-pool-config/talent-pool-config.service";
import { derivedAsync } from "ngxtension/derived-async";
import { catchError, of } from "rxjs";

@Component({
  selector: "new-ui-dashboard",
  templateUrl: "./new-ui-dashboard.component.html",
  imports: [
    PageheaderComponent,
    TranslateDirective,
    NewUiDashboardOpenTasksComponent,
    NewUiDashboardEventsComponent,
    NewUiDashboardSharingComponent,
    NewUiDashboardBirthdaysComponent,
    NewUiDashboardReleaseNotesComponent,
    NewUiDashboardCandidateStatusComponent,
    NewUiDashboardMilestoneComponent,
    NewUiDashboardMilestoneCandidateComponent,
    NewUiDashboardTalentPoolRequestsComponent,
    NewUiDashboardTalentPoolSharingsComponent,
  ],
})
export class NewUiDashboardComponent {
  private readonly talentPoolConfigService = inject(TalentPoolConfigService);
  protected readonly settings = inject(SettingsService);
  protected milestoneRowCount = 1;

  onMilestoneRowCountChange(rowCount: number): void {
    this.milestoneRowCount = rowCount;
  }

  protected readonly config = derivedAsync(() =>
    this.talentPoolConfigService.getParticipationInfo().pipe(catchError(() => of(null)))
  );

  protected readonly dashboardVisibility = computed(() => ({
    isVisible: this.isDashboardVisible(),
    talentPool:
      SHOW_TALENT_POOL_UI &&
      (this.settings.hasModule("talentPool") ||
        this.config()?.isUserInPool ||
        this.config()?.isContributorInPool ||
        this.config()?.canContributeToAnkaadiaPool),
  }));

  protected readonly title = this.getTitle();

  private isDashboardVisible(): boolean {
    return this.settings.hasAnyPermission([
      UserPermission.User,
      UserPermission.CandidateManager,
      UserPermission.Candidate,
    ]);
  }

  private getTitle(): string {
    const hour = DateTime.now().getHour();
    const userName = this.settings.userFirstName ?? "";

    if (hour >= 5 && hour < 12) {
      return translateSafely("dashboard.morningTitle", { userName });
    } else if (hour >= 12 && hour < 18) {
      return translateSafely("dashboard.dayTitle", { userName });
    } else {
      return translateSafely("dashboard.eveningTitle", { userName });
    }
  }
}
